export default __webpack_public_path__ + "static/media/E3.2135d4bb.jpeg";